import React from "react";
import { Space, Row, Col, Tree, Button, Form } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import withRouter from "../withRouter";
import AssignVehiclesToGeofenceStore from "../store/AssignVehiclesToGeofenceStore";

const treeData = {
  companyId: "178",
  name: "awtltest2",
  type: "company",
  mtype: "fleet.model.CompanyTreeModel",
  children: [
    {
      deviceGroupId: "165",
      text: "Test Group 1",
      type: "deviceGroup",
      zoneId: "64917",
      checked: true,
      children: [
        {
          text: "9958 BAA",
          mtype: "fleet.model.VehicleTreeModel",
          vehicleId: "20885",
          deviceGroupId: "165",
          leaf: "true",
          checked: true,
        },
      ],
    },
    {
      deviceGroupId: "208",
      text: "Test Group 3",
      type: "deviceGroup",
      zoneId: "64917",
      checked: true,
      children: [
        {
          text: "4165 ARA",
          mtype: "fleet.model.VehicleTreeModel",
          vehicleId: "40175",
          deviceGroupId: "208",
          leaf: "true",
          checked: true,
        },
        {
          text: "4693 RBA",
          mtype: "fleet.model.VehicleTreeModel",
          vehicleId: "40244",
          deviceGroupId: "208",
          leaf: "true",
          checked: true,
        },
      ],
    },

    {
      text: "Test Plate2",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "33614",
      leaf: "true",
      checked: false,
    },
    {
      text: "ruptela-test",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "35209",
      leaf: "true",
      checked: false,
    },
    {
      text: "1234",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "44717",
      leaf: "true",
      checked: false,
    },
    {
      text: "GS900",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "54553",
      leaf: "true",
      checked: false,
    },
    {
      text: "81691",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "79638",
      leaf: "true",
      checked: false,
    },
    {
      text: "Ruptela Test",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "101328",
      leaf: "true",
      checked: false,
    },
    {
      text: "iridium-test",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "101885",
      leaf: "true",
      checked: false,
    },
    {
      text: "Pioneerx10",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "101904",
      leaf: "true",
      checked: false,
    },
    {
      text: "topflytech121",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "101905",
      leaf: "true",
      checked: false,
    },
    {
      text: "TEMPsensor",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "104612",
      leaf: "true",
      checked: false,
    },
    {
      text: "3234343232",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "55196",
      leaf: "true",
      checked: false,
    },
    {
      text: "test Device type",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "57029",
      leaf: "true",
      checked: false,
    },
    {
      text: "test Device type",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "57034",
      leaf: "true",
      checked: false,
    },
    {
      text: "Test devicetype",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "57078",
      leaf: "true",
      checked: false,
    },
    {
      text: "fleet-test",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "57795",
      leaf: "true",
      checked: false,
    },
    {
      text: "test123",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "57879",
      leaf: "true",
      checked: false,
    },
    {
      text: "866069064950445",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "57891",
      leaf: "true",
      checked: false,
    },
    {
      text: "test239",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "58102",
      leaf: "true",
      checked: false,
    },
    {
      text: "testTempRep",
      mtype: "fleet.model.VehicleTreeModel",
      vehicleId: "58397",
      leaf: "true",
      checked: false,
    },
  ],
};

class AssignVehiclesToGeofence extends React.Component {
  constructor(props, context) {
    super(props);

    this.state = {
      deviceGrpAndVehicles: [],
      checkedVehiclesAndGrps: [],
    };

    this.assignVehToGeoStore = new AssignVehiclesToGeofenceStore(this);

    console.log(this.props);
  }

  async componentDidMount() {
    const data = await this.assignVehToGeoStore.getDeviceGrpAndVehicles({
      // companyId: 13,
      // zoneId: 5847,
      companyId: this.props.companyId,
      zoneId: this.props.zoneId,
    });

    this.setState({ deviceGrpAndVehicles: data.result });
  }

  // onCheck = (checkedKeys, info) => {
  //   const checkedNodes = info.checkedNodes;
  //   const result = [];

  //   checkedNodes.forEach((node) => {
  //     // 1. If node is a vehicle (leaf)
  //     if (node.leaf === "true" || node.leaf === true) {
  //       result.push({ vehicleId: node.vehicleId });

  //       // 2. If node is a device group (non-leaf)
  //     } else if (node.deviceGroupId) {
  //       // a) Has children
  //       if (node.children && node.children.length > 0) {
  //         const allChildrenChecked = node.children.every((child) =>
  //           checkedKeys.includes(child.vehicleId)
  //         );

  //         if (!allChildrenChecked) {
  //           result.push({
  //             deviceGroupId: node.deviceGroupId,
  //             vehicles: node.children.map((child) => ({
  //               vehicleId: child.vehicleId,
  //             })),
  //           });
  //         }
  //       }
  //       // b) No children (empty group but still checked)
  //       else {
  //         result.push({
  //           deviceGroupId: node.deviceGroupId,
  //         });
  //       }
  //     }
  //   });

  //   console.log("Final result to send:", result);

  //   this.setState({ checkedVehiclesAndGrps: result });
  // };

  onClickSave = () => {
    // const checkedVehicles = this.state.checkedVehiclesAndGrps;

    const data = {
      companyId: this.props.companyId,
      zoneId: this.props.zoneId,
      // companyId: 13,
      // zoneId: 5847,
      vehicleId: [],
      grouppId: [],
    };

    console.log(data, "data");

    // checkedVehicles.forEach((item) => {
    //   if (item.vehicleId && !item.deviceGroupId) {
    //     // Individual vehicle
    //     data.vehicleId.push(item.vehicleId);
    //   } else if (item.deviceGroupId) {
    //     // Group entry
    //     data.grouppId.push(item.deviceGroupId);
    //   }
    // });

    // console.log(data, "data");
  };

  convertTreeData = (data) => {
    const result = {
      title: data.name,
      key: `company-${data.companyId}`,
      children: [],
    };

    // Process children
    data.children.forEach((child) => {
      if (child.type === "deviceGroup") {
        const groupNode = {
          title: child.text,
          key: `group-${child.deviceGroupId}`,
          children: [],
        };

        child.children?.forEach((vehicle) => {
          groupNode.children.push({
            title: vehicle.text,
            key: `vehicle-${vehicle.vehicleId}`,
            isLeaf: true,
            checked: vehicle.checked,
          });
        });

        result.children.push(groupNode);
      } else {
        // vehicle without group
        result.children.push({
          title: child.text,
          key: `vehicle-${child.vehicleId}`,
          isLeaf: true,
          checked: child.checked,
        });
      }
    });

    return [result];
  };

  onCheck = (checkedKeys, info) => {
    console.log(checkedKeys, info);
  };
  closeModal = () => {
    this.props.closeModal();
  };

  render() {
    return (
      <div style={{ padding: 0, height: "100%" }}>
        <Form
          layout="vertical"
          name="assignVehicles"
          className="formClass"
          style={{ maxWidth: "100%", padding: 0, height: "92%" }}
        >
          <Row className="overflowFormInputs">
            <Col span={24} className="formColumnClass">
              {this.props.openTree && (
                <Tree
                  checkable
                  treeData={this.props.treeData}
                  onCheck={this.props.onCheck}
                  checkedKeys={this.props.checkedKeys}
                  defaultExpandAll
                />
              )}
            </Col>
          </Row>
          <div className="formFooter">
            <Button
              className="formsCancelButton"
              onClick={() => {
                this.closeModal(); 
              }}
            >
              {this.context.translate(
                "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
              )}
            </Button>
            <Button
              htmlType="submit"
              loading={this.state.loading}
              className="formsSaveButton"
            >
              {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
            </Button>
          </div>

          {/* <div className="formBtnGroup">
            <Button
              className="formCancelButton"
              onClick={this.props.onClose}
            >
              {this.context.translate(
                "_FLEET_DASHBORD_SHOWPOI_CANCELBTN_"
              )}
            </Button>
            <Button
              type="primary"
              className="formSaveButton"
              onClick={this.props.onSubmit}
            >
              {this.context.translate("_SUBMIT_")}
            </Button>
          </div> */}
        </Form>
      </div>
    );
  }
}
AssignVehiclesToGeofence.contextType = StoreContext;
export default observer(withRouter(AssignVehiclesToGeofence));